import React from 'react';

const DuplicateWeekModal = ({ darkMode, theme, weekToDuplicate, duplicateWeek, setShowDuplicateMenu, setWeekToDuplicate }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className={darkMode ? 'rounded-2xl p-6 w-full max-w-md shadow-2xl bg-slate-800 text-white' : 'rounded-2xl p-6 w-full max-w-md shadow-2xl bg-white'}>
        <h2 className="text-xl font-semibold mb-2">Duplicate Week {weekToDuplicate + 1}</h2>
        <p className={darkMode ? 'text-sm mb-6 text-slate-400' : 'text-sm mb-6 text-slate-600'}>
          Where would you like to insert this week's runs?
        </p>
        <div className="space-y-3">
          <button
            onClick={() => duplicateWeek(weekToDuplicate, 'next')}
            className={'w-full text-white py-4 rounded-xl font-medium text-left px-5 ' + theme.primary + ' ' + theme.hover}
          >
            <div className="font-semibold mb-1">Insert as Next Week</div>
            <div className="text-sm opacity-90">Add immediately after Week {weekToDuplicate + 1}</div>
          </button>
          <button
            onClick={() => duplicateWeek(weekToDuplicate, 'end')}
            className={darkMode ? 'w-full py-4 rounded-xl font-medium text-left px-5 bg-slate-700 hover:bg-slate-600' : 'w-full py-4 rounded-xl font-medium text-left px-5 bg-slate-100 hover:bg-slate-200'}
          >
            <div className="font-semibold mb-1">Add to End</div>
            <div className={darkMode ? 'text-sm text-slate-400' : 'text-sm text-slate-600'}>Append as the last week of your plan</div>
          </button>
        </div>
        <button
          onClick={() => {
            setShowDuplicateMenu(false);
            setWeekToDuplicate(null);
          }}
          className={darkMode ? 'w-full mt-4 py-3 rounded-xl font-medium bg-slate-700 hover:bg-slate-600' : 'w-full mt-4 py-3 rounded-xl font-medium bg-slate-100 hover:bg-slate-200'}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DuplicateWeekModal;
